import React, { useEffect, useState } from 'react';
import ContainerHeader from '../components/ContainerHeader';
import GridContainer from '@jumbo/components/GridContainer';
import { Grid } from '@mui/material';

import ClickIdeasWidget from 'routes/Metrics/Classic/ClickIdeaWidget';
import useFormsHook from './hooks/useFormsHooks';
import EnquiryFormModal from '../CRM/ContactOverview/EnquiryForm/EnquiryForm';

const FormPage = props => {
  const { fromPageData, openEnquiryForm, setOpenEnquiryForm, handleEnquiryformSubmit } = useFormsHook();
  return (
    // <PageContainer heading={<IntlMessages id="pages.dashboard" />} breadcrumbs={breadcrumbs}>
    <div className="app-wrapper">
      <ContainerHeader match={props.match} title={'Forms'} />
      <GridContainer>
        <Grid item xs={12} md={12} xl={12}>
          <GridContainer>
            {fromPageData.map((item, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <ClickIdeasWidget
                  number={item.cardValue ? item.CardValue : null}
                  subTitle={item.cardTitle}
                  backgroundColor={item.backgroundColor}
                  icon={item.icon}
                  clicklinkOnArrow={item.onClick}
                />
              </Grid>
            ))}
          </GridContainer>
        </Grid>
      </GridContainer>
      <EnquiryFormModal
        open={openEnquiryForm}
        setOpen={setOpenEnquiryForm}
        handleEnquiryformSubmit={handleEnquiryformSubmit}
      />
    </div>
  );
};

export default FormPage;
